import React from 'react'

export default ({ modalMessages }) => (
  <div className="fds-c-modal__section fds-u-text-align-center fds-u-p3">
    <p className="fds-c-text-body fds-u-mb0">
      {modalMessages.message ||
        'There was an error adding item to your cart. Please try again.'}
    </p>
  </div>
)



// WEBPACK FOOTER //
// ./client/components/modals/cart/modalErrorMessage.js